/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import { IconProps } from "../types";
const CaretDownIcon = ({
  size = 24,
  ...props
}: IconProps) => {
  return <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width={size} height={size} {...props}><path d="M12.79 16.864a1 1 0 0 1-1.58 0l-6.524-8.64C4.22 7.61 4.68 6.75 5.475 6.75h13.05c.794 0 1.254.86.79 1.474z" /></svg>;
};
export default CaretDownIcon;